/**
 * "Your password was changed" - carried from the change-password forms to the
 * sign-in page they end on.
 *
 * A change ends every session, this one included, so both forms sign out and
 * land on `/login`; without a word there the merchant is left wondering whether
 * anything happened. The flag rides in session storage rather than in router
 * state because signing out redirects on its own as well, and whichever
 * navigation lands last must not lose it. It is shown once.
 */
const KEY = 'neon.passwordChanged';

export function markPasswordChanged() {
  try {
    window.sessionStorage.setItem(KEY, '1');
  } catch {
    // Storage blocked: the sign-in page simply says nothing, as it did before.
  }
}

/** Whether the sign-in page should say so. Pair with `clearPasswordChanged` once shown. */
export function passwordJustChanged(): boolean {
  try {
    return window.sessionStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
}

export function clearPasswordChanged() {
  try {
    window.sessionStorage.removeItem(KEY);
  } catch {
    // Nothing was stored.
  }
}
